import { LitElement, html, svg } from 'lit';

export class IconChevronUp16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11 8 5.5l5.5 5.5"></path></svg>`; }
}
if (!customElements.get('f-icon-chevron-up16', IconChevronUp16)) {
  customElements.define('f-icon-chevron-up16', IconChevronUp16);
}